import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../Redux/Slices/Utility/LoginSlice";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import "./Login.css";
import loginImage from "../../Asset/Image/Login/Login.png";
import { FaFacebookF, FaGoogle, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { Alert } from "react-bootstrap";
import { startLoader, stopLoader } from "../../Redux/Slices/Utility/loaderSlice";
import Loader from '../Utility/Loader.jsx';
import { IoMdEyeOff } from "react-icons/io";
import { IoEye } from "react-icons/io5";


function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Correctly named as navigate for clarity
  const [rememberMe, setRememberMe] = useState(false);
  const [showAlert, setShowAlert] = useState(false);


  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => setShowPassword(prev => !prev);

  let UserLogin = useSelector((state) => state.UserLogin);
  console.log('UserLogin', UserLogin);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      dispatch(startLoader());

      if (rememberMe) {
        localStorage.setItem(
          "rememberLogin",
          btoa(JSON.stringify({ userName: data.Username, Password: btoa(data.Password) }))
        );
      } else {
        localStorage.removeItem("rememberLogin");
      }
      
      // await dispatch(loginUser(data, navigate))?.unwrap(); Monika a aa mukyu tu loader mate but error avti ti atle me bandh kryu
      await dispatch(loginUser(data, navigate));
    } catch (error) {
      console.error("Login Error:", error);
    } finally {
      dispatch(stopLoader());
    }
  };


  useEffect(() => {
    // if (UserLogin.user && UserLogin.isAuthenticated === true) { 
    //   dispatch(fetchMenuPermition())
    //   navigate("/");
    // }
    // if (UserLogin.user && UserLogin.isAuthenticated === true) {
    //   dispatch(fetchMenuPermition())
    //   navigate("/");
    // }


    if (UserLogin.user) {
      navigate('/');
    }

  }, [UserLogin]);

  // const handleForgotPassword = async (email) => {
  //   dispatch(forgotPassword(email));
  // };

  useEffect(() => {
    let storedUserdata = localStorage?.getItem("rememberLogin");
    if (storedUserdata) {
      storedUserdata = JSON.parse(atob(storedUserdata))
      setValue("Username", storedUserdata.userName);
      setValue("Password", atob(storedUserdata.Password));
      setRememberMe(true); // Assuming you want to check the checkbox if the username is remembered
    }
  }, [UserLogin]);

  return (
    <>
      <Loader />
      <div className="container-fluid">
        <form onSubmit={handleSubmit(onSubmit)} className="row align-items-center">
          <div className="login-container">
            <div className="login-box">
              <h3>Welcome Back</h3>
              <p>Please login to your account</p>
              <div className="mb-3">
                <input
                  type="Text"
                  placeholder="Username"
                  className="form-control"
                  name="Username"
                  {...register("Username", {
                    required: "This field is required",
                  })}
                />
                {errors.Username && (
                  <span className="validation">{errors.Username.message}</span>
                )}
              </div>

              <div className="mb-3 position-relative">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  className="form-control"
                  name="Password"
                  {...register("Password", {
                    required: "This field is required",
                  })}
                />
                <span
                  className="position-absolute top-50 end-0 translate-middle-y me-3 cursor-pointer"
                  onClick={togglePasswordVisibility}
                  style={{ cursor: "pointer", fontSize: "1.2rem" }}
                >
                  {showPassword ? <IoMdEyeOff /> : <IoEye />}
                </span>
                {errors.Password && (
                  <span className="validation text-danger">{errors.Password.message}</span>
                )}
              </div>

              <div className="text-start mb-3">
                <span className="chekbox">
                  <input
                    type="checkbox"
                    id="rememberMe"
                    name="rememberMe"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    className="mx-1"
                  ></input>
                  <label htmlFor="rememberMe">Remember Me</label>
                </span>
                {/* <span
                className="forget_pass float-end mb-3"
                onClick={handleSubmit(handleForgotPassword)}
              >
                <a href="">Forgot Password</a>
              </span> */}
              </div>
              <button
                className="savepanelBtn btn-primary ml-md-2 w-100 mb-3"
                type="submit"
              >
                Login
              </button>
              <div>
                <Link
                  to="/Register"
                >
                  <span className="float-end" >
                    Don't have an Account ?
                  </span>
                </Link>
                <Link
                  to="/forgotpassword"
                >
                  <span className="float-end" >
                    Forgot Password
                  </span>
                </Link>
              </div>
              <Alert
                variant="success"
                show={showAlert}
                onClose={() => setShowAlert(false)}
                dismissible
              >
                Password reset email sent!
              </Alert>
            </div>
          </div>







          {/* <div className="col-sm-5 col-md-5 align-items-center">
            
            <div> */}
          {/* <span className="chekbox">
                <input
                  type="checkbox"
                  id="rememberMe"
                  name="rememberMe"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  className="mx-1"
                ></input>
                <label htmlFor="rememberMe">Remember Me</label>
              </span> */}
          {/* <span
                className="forget_pass float-end mb-3"
                onClick={handleSubmit(handleForgotPassword)}
              >
                <a href="">Forgot Password</a>
              </span> */}
          {/* </div> */}

          {/* <button
              className="savepanelBtn btn-primary ml-md-2 w-100 mb-3"
              type="submit"
            >
              Login
            </button>
            <div>
              <Link
                to="/Register"
                // style={{ color: "#337357", fontWeight: "700" }}
              >
                <span className="float-end">
                 Don't have an Account ?
                </span>
              </Link>
            </div>
            <Alert
              variant="success"
              show={showAlert}
              onClose={() => setShowAlert(false)}
              dismissible
            >
              Password reset email sent!
            </Alert> */}
          {/* <p className="social-text">Or Sign up with social platforms</p>
            <div className="social-media">
              <a href="#" className="social-icon">
                <FaFacebookF />
              </a>
              <a href="#" className="social-icon">
                <FaTwitter />
              </a>
              <a href="#" className="social-icon">
                <FaGoogle />
              </a>
              <a href="#" className="social-icon">
                <FaLinkedinIn />
              </a>
            </div> */}
          {/* </div> */}
        </form>
      </div>
    </>
  );
}
export default Login;
